export const formatUnits = (units) => {
  return units?.map((unit) => ({
    label: unit?.description,
    courseCode: unit?.code,
    courseId: unit?.courseId,
    value: unit?._id,
    subunits: unit?.subunits,
  }));
};

export const getUnitIDList = (units) => {
  return units?.map((unit) =>  unit?._id);
};

export const getUnitTitleList = (units) => {
  return units?.map((unit) =>  unit?.description);
};

export const convertUnitListToMap = (units) => {
  const unitMap = {}
  units.forEach(unit => {
    unitMap[unit?._id] = {
      label: unit?.description,
      courseCode: unit?.code,
      courseId: unit?.courseId,
      value: unit?._id,
      subunits: unit?._subunits,
    }
  })
}